
// export default App;

import './App.css';
import { useState } from 'react';
import { BrowserRouter as Router, Routes, Route, useNavigate } from "react-router-dom";

// صفحات
import HomePage from "./pages/HomePage";
import ProductsPage from "./pages/ProductsPage";
import ProductDetails from "./pages/ProductDetails";
import AboutPage from "./pages/AboutPage";
import NotFound from "./pages/NotFound";
import CartPage from './pages/CartPage';
import Navbar from './pages/Navbar';
import KitchenPage from './pages/KitchenPage';
import MakeupPage from './pages/MakeupPage';
import ClothesPage from './pages/ClothesPage';
import DarOulmesCheckout from './pages/CheckoutPage';
import Login from './pages/Login';
import Register from './pages/Register';
import CustomerDashboard from './pages/CustomerDashboard';
import Admin from './app/admin/Admin';
import JewelleryPage from './pages/JewelleryPage';
import ProtectedRoute from './ProtectedRoute';
import HowItWorksPage from './pages/HowItWorksPage';
import DeliveryDashboard from './pages/DeliveryDashboard';
import Profile from './pages/Profile';
import CategoriesPage from './pages/CategoriesPage';
import ProductCsvImporter from './pages/ProductCsvImporter';
import PerfumesPage from './pages/PerfumesPage';

// ─── Inner component: has access to useNavigate ───────────────────────────────
function AppRoutes() {
  const navigate = useNavigate();

  // Initialise auth state from localStorage (persisted by Login / Register)
  const [authUser, setAuthUser] = useState(() => {
    try {
      const stored = localStorage.getItem("user");
      return stored ? JSON.parse(stored) : null;
    } catch {
      return null;
    }
  });

  // Called by <Login> and <Register> on successful authentication
  const handleAuthSuccess = ({ token, user }) => {
    localStorage.setItem("access_token", token);
    localStorage.setItem("user", JSON.stringify(user));
    setAuthUser(user);

    // Send admins to the admin panel, everyone else to the dashboard
    navigate(user.role === "ADMIN" ? "/admin" :user.role === "DELIVERY"? "/delivery":"/dashboard", { replace: true });
  };

  // Called by <Navbar> or any logout button
  const handleLogout = () => {
    localStorage.removeItem("access_token");
    localStorage.removeItem("user");
    setAuthUser(null);
    navigate("/login", { replace: true });
  };

  return (
    <div className="min-h-screen w-full relative">
      {/* Background Image */}
      <img
        src="/Gemini_Generated_Image_2tqn112tqn112tqn.png"
        alt="Background"
        className="fixed top-0 left-0 w-full h-full object-fill opacity-50 scale-110 -z-10"
      />

      {/* Content */}
      <div className="relative z-10">
        <Navbar authUser={authUser} onLogout={handleLogout} />

        <Routes>
          {/* ── Public routes ── */}
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/how-it-works" element={<HowItWorksPage />} />
          <Route path="/categories"    element={<CategoriesPage />} />
          <Route path="/ProductCsvImporter"    element={<ProductCsvImporter />} />

          <Route
            path="/login"
            element={
              <Login
                onAuthSuccess={handleAuthSuccess}
                onNavigateToRegister={() => navigate("/register")}
              />
            }
          />

          <Route
            path="/register"
            element={
              <Register
                onAuthSuccess={handleAuthSuccess}
                onNavigateToLogin={() => navigate("/login")}
              />
            }
          />

          {/* ── Protected routes ── */}
          <Route path="/profile"    element={<ProtectedRoute><Profile /></ProtectedRoute>} />
          <Route path="/products"    element={<ProtectedRoute><ProductsPage /></ProtectedRoute>} />
          <Route path="/product/:id" element={<ProtectedRoute><ProductDetails /></ProtectedRoute>} />
          <Route path="/makeup"      element={<ProtectedRoute><MakeupPage /></ProtectedRoute>} />
          <Route path="/kitchen"     element={<ProtectedRoute><KitchenPage /></ProtectedRoute>} />
          <Route path="/clothes"     element={<ProtectedRoute><ClothesPage /></ProtectedRoute>} />
          <Route path="/jewellery"   element={<ProtectedRoute><JewelleryPage /></ProtectedRoute>} />
          <Route path="/perfumes"   element={<ProtectedRoute><PerfumesPage /></ProtectedRoute>} />
          <Route path="/cart"        element={<ProtectedRoute><CartPage /></ProtectedRoute>} />
          <Route path="/checkout"    element={<ProtectedRoute><DarOulmesCheckout /></ProtectedRoute>} />
          <Route path="/dashboard"   element={<ProtectedRoute><CustomerDashboard authUser={authUser} /></ProtectedRoute>} />
          <Route path="/admin"       element={<ProtectedRoute><Admin authUser={authUser} /></ProtectedRoute>} />
          <Route path="/delivery"       element={<ProtectedRoute><DeliveryDashboard authUser={authUser} /></ProtectedRoute>} />

          {/* ── Fallback ── */}
          <Route path="*" element={<NotFound />} />
        </Routes>
      </div>
    </div>
  );
}

// ─── Root component: provides the Router context ─────────────────────────────
function App() {
  return (
      <AppRoutes />
  );
}

export default App;